// client/src/components/categorias/CategoriaRow.js
import React from 'react';
import { MoreVertical } from 'lucide-react';
import PropTypes from 'prop-types';

const CategoriaRow = ({ categoria, onOpenActions, loading }) => {
    // ✅ CORREÇÃO CRÍTICA: Validar categoria e ID antes de renderizar
    if (!categoria) {
        console.warn('⚠️ [CATEGORIA_ROW] Categoria undefined');
        return (
            <tr>
                <td colSpan="6" className="td-empty">
                    Dados da categoria em processamento...
                </td>
            </tr>
        );
    }

    if (!categoria._id) {
        console.error('❌ [CATEGORIA_ROW] Categoria sem ID:', categoria);
        return (
            <tr>
                <td colSpan="6" className="td-empty text-red-600">
                    Erro: Categoria inválida (sem ID)
                </td>
            </tr>
        );
    }

    console.log('🔍 [CATEGORIA_ROW] Renderizando categoria:', {
        id: categoria._id,
        nome: categoria.nome,
        tipo: categoria.tipo
    });

    const getTipoDisplay = (tipo) => {
        const tipos = {
            'servico': 'Serviço',
            'produto': 'Produto',
            'recurso': 'Recurso',
            'curso': 'Curso',
            'geral': 'Geral'
        };
        return tipos[tipo] || tipo;
    };

    const getStatusBadge = (ativo) => {
        return ativo ? (
            <span className="badge badge-green">Ativa</span>
        ) : (
            <span className="badge badge-red">Inativa</span>
        );
    };

    // ✅ CORREÇÃO: Exibição da categoria pai com validação
    const getCategoriaPaiDisplay = () => {
        if (!categoria.categoriaPai) {
            return (
                <span className="text-gray-400 text-sm">—</span>
            );
        }
        
        // Se categoriaPai for um objeto populado
        if (typeof categoria.categoriaPai === 'object' && categoria.categoriaPai.nome) {
            return (
                <div>
                    <div className="font-medium text-sm">{categoria.categoriaPai.nome}</div>
                    <div className="text-xs text-gray-500">
                        {getTipoDisplay(categoria.categoriaPai.tipo)}
                    </div>
                </div>
            );
        }
        
        // Se for apenas o ID (não populado)
        return (
            <span className="text-gray-500 text-sm">Carregando...</span>
        );
    };

    return (
        <tr className="table-row-hover">
            <td className="td-name">
                <div>
                    <div className="font-medium">{categoria.nome}</div>
                    {categoria.descricao && (
                        <div className="text-sm text-gray-500 truncate max-w-xs">
                            {categoria.descricao}
                        </div>
                    )}
                </div>
            </td>
            <td>
                <span className="badge badge-outline">
                    {getTipoDisplay(categoria.tipo)}
                </span>
            </td>
            <td>
                {getCategoriaPaiDisplay()}
            </td>
            <td>
                {getStatusBadge(categoria.ativo)}
            </td>
            <td>
                <span className="text-sm font-medium">
                    {categoria.metadata?.quantidadeItens || 0}
                </span>
            </td>
            <td className="text-right">
                <button
                    onClick={() => onOpenActions(categoria)}
                    title="Ações"
                    className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={loading}
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

CategoriaRow.propTypes = {
    categoria: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        nome: PropTypes.string.isRequired,
        descricao: PropTypes.string,
        tipo: PropTypes.oneOf(['servico', 'produto', 'recurso', 'curso', 'geral']).isRequired,
        ativo: PropTypes.bool,
        categoriaPai: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                _id: PropTypes.string,
                nome: PropTypes.string,
                tipo: PropTypes.string
            })
        ]),
        metadata: PropTypes.shape({
            quantidadeItens: PropTypes.number
        })
    }).isRequired,
    onOpenActions: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default CategoriaRow;